import { EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Global } from '../../../../common/global';
import { DataService } from '../../../../services/api/data.service';
var NegativeDefaultDialogComponent = /** @class */ (function () {
    function NegativeDefaultDialogComponent(dataService) {
        this.dataService = dataService;
        this.showDialogChange = new EventEmitter();
        this.usePositiveAmount = new EventEmitter();
        this.enableAutoCorrect = new EventEmitter();
        this.setting = true;
        this.showDialogValue = false;
    }
    Object.defineProperty(NegativeDefaultDialogComponent.prototype, "showDialog", {
        get: function () {
            return this.showDialogValue;
        },
        set: function (value) {
            this.showDialogValue = value;
            this.showDialogChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    NegativeDefaultDialogComponent.prototype.onUsePositiveAmount = function () {
        this.usePositiveAmount.emit({ dataItem: this.dataItem, fieldName: this.fieldName });
    };
    NegativeDefaultDialogComponent.prototype.onEnableAutoCorrect = function () {
        var _this = this;
        var userPref = { Key: 'SalaryRecords.AutoFlipAmounts', Value: 'true' };
        this.dataService.Preferences_SetUserPreference(userPref).subscribe(function () {
            _this.updateUserPreference(userPref);
            _this.enableAutoCorrect.emit({ dataItem: _this.dataItem, fieldName: _this.fieldName });
        });
    };
    NegativeDefaultDialogComponent.prototype.disableAutoCorrect = function () {
        var _this = this;
        var userPref = { Key: 'SalaryRecords.AutoFlipAmounts', Value: 'false' };
        this.dataService.Preferences_SetUserPreference(userPref).subscribe(function () {
            _this.updateUserPreference(userPref);
            _this.usePositiveAmount.emit({ dataItem: _this.dataItem, fieldName: _this.fieldName });
        });
    };
    NegativeDefaultDialogComponent.prototype.onDialogAction = function (action) {
        this.showDialogChange.emit(false);
        if (action === 'UsePositiveAmountThisTime') {
            this.onUsePositiveAmount();
        }
        if (action === 'DisableThisBehaviour') {
            this.disableAutoCorrect();
        }
        if (action === 'EnableAutoCorrect') {
            this.onEnableAutoCorrect();
        }
    };
    Object.defineProperty(NegativeDefaultDialogComponent.prototype, "branding", {
        get: function () {
            return environment.branding;
        },
        enumerable: true,
        configurable: true
    });
    NegativeDefaultDialogComponent.prototype.updateUserPreference = function (userPref) {
        var userPreferences = Global.USER_PREFERENCES;
        var updatedUserPref;
        if (userPreferences) {
            updatedUserPref = userPreferences.find(function (data) {
                return data.Key === userPref.Key;
            });
        }
        if (updatedUserPref) {
            updatedUserPref.Value = userPref.Value;
        }
        else {
            userPreferences.push(userPref);
        }
        Global.USER_PREFERENCES = userPreferences;
    };
    return NegativeDefaultDialogComponent;
}());
export { NegativeDefaultDialogComponent };
